{
  "version": 1,
  "asset_id": "7dfbc1f9-4c02-4df8-8ffc-fd54a0765346",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7dfbc1f9-4c02-4df8-8ffc-fd54a0765346/sleeve-fitzer-2-440.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7dfbc1f9-4c02-4df8-8ffc-fd54a0765346/sleeve-fitzer-2-440.png",
  "original_filename": "sleeve-fitzer-2-440.png",
  "size": 129471,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:43Z"
}
